<template>
  <div id="overview" class="row Tabla2 mt-3 mb-4">
    <div class="col-12 mb-4">
      <!-- TODO: Uncomment when implemented in API
      <div class="progress" v-if="cardType === 'MEMBER_BUDGET'">
        <div
          class="progress-bar progress--curent"
          role="progressbar"
          :style="`width: ${spentPercent}%`"
        ></div>
        <div
          class="progress-bar progress--total"
          role="progressbar"
          :style="`width: ${availablePercent}%`"
        ></div>

      </div>-->
      <!-- TODO: Uncomment when implemented in API
      <div class="Tabla2-theadTit">{{cardSpent | currency('€', 2, {symbolOnLeft : false, thousandsSeparator: '.'}) }}</div>
      <div class="Tabla2-theadSubtit" v-t.preserve="{path: 'cards_detail_spent'}"></div>-->
    </div>
    <div
      class="col-4 Tabla2-th"
      v-t.preserve="{ path: 'cards_detail_budget' }"
    ></div>
    <div class="col-7 Tabla2-td">{{ cardAssignedBudgetName }}</div>
    <div
      class="col-4 Tabla2-th"
      v-t.preserve="{ path: 'card_mp_identifier' }"
    ></div>
    <div class="col-7 Tabla2-td" v-if="cardMPNumber">
      {{ cardMPNumber }}
    </div>
    <div class="col-7 Tabla2-td" v-else>
      {{ $t('card_not_generated') }}
    </div>
  </div>
</template>

<script>
import _cardDetailMixin from '../../_mixins/_cardDetailMixin'
export default {
  name: 'CardOverView',
  mixins: [_cardDetailMixin],
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  computed: {
    spentPercent () {
      return (this.cardSpent * 100) / this.cardAssigned
    },
    transactionAmountIntegers () {
      return this.transaction ? `${this.transaction.amount}`.split('.')[0] : 0
    },
    transactionAmountDecimals () {
      return this.transaction ? `${this.transaction.amount}`.split('.')[1] : 0
    },

    cardSpentIntegers () {
      return this.cardSpent ? `${this.cardSpent}`.split('.')[0] : 0
    },
    cardSpentDecimals () {
      return this.cardSpent ? `${this.cardSpent}`.split('.')[1] : 0
    }
  }
}
</script>
